import type { SxProps, Theme } from '@mui/material/styles';
import { alpha, styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const inputCompactLineHeight = 1.6;

export const inputCompactOutlinedSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'background.paper',
    borderRadius: '2px',
    boxShadow: (theme: Theme) => `0px 1px 0px 0px ${alpha(theme.palette.neutral.black, 0.15)}`,
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    minHeight: 50,
    letterSpacing: 0,
    lineHeight: inputCompactLineHeight,
    padding: 0,
    transition: (theme: Theme) =>
      theme.transitions.create(['box-shadow', 'border-color'], {
        duration: 200,
        easing: theme.transitions.easing.easeOut,
      }),
  },
  '& .MuiOutlinedInput-input': {
    padding: '12px 10px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider',
    borderWidth: 1,
    transition: (theme: Theme) =>
      theme.transitions.create(['border-color'], {
        duration: 200,
        easing: theme.transitions.easing.easeOut,
      }),
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider',
  },
  '& .MuiOutlinedInput-root:not(.Mui-error).Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.main',
    borderWidth: 1,
  },
  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-error:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'error.main',
    borderWidth: 1,
  },
  '& .MuiOutlinedInput-input::placeholder': {
    color: (theme: Theme) => alpha(theme.palette.text.primary, 0.5),
    opacity: 1,
  },
};

export const StyledInput = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 14,
    backgroundColor: theme.palette.background.paper,
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: 2,
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    fontWeight: 600,
  },
}));
